<template>
    <b-card>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Create New Order - Options" id="confirm-order-modal" ok-title="Create Order"
                     v-model="modalShow"
                     :ok-disabled="invalid"
                     :busy="isBusy"
                     @ok="handleOk">
                <h5>Please enter order details:</h5>

                <b-form>
                    <validation-provider
                            name="Brand"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-brand"
                                label="Brand:"
                                label-for="input-brand"
                        >
                            <b-form-select v-model="brandSelected" :options="brandOptions" id="input-brand"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                            name="Shipping Method"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-shipping"
                                label="Shipping Method:"
                                label-for="input-shipping-method"
                        >
                            <b-form-select v-model="shippingSelected" :options="shippingOptions"
                                           id="input-shipping-method"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                            name="Tracking Number"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-tracking"
                                label="Tracking Number:"
                                label-for="input-tracking-number"
                        >
                            <b-form-input v-model="trackingNumber" type="text" id="input-tracking-number"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Create New Packaging - Options" id="confirm-order-modal" ok-title="Create Packaging"
                     v-model="modalNewPackageShow"
                     :ok-disabled="invalid"
                     :busy="isBusy"
                     @ok="handleOKAddPackage">
                <h5>Please enter order details:</h5>

                <b-form>
                    <validation-provider
                            name="Order Id"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-order-id"
                                label="Order Id:"
                                label-for="input-order-id"
                        >
                            <b-form-input v-model="orderId"  id="input-order-id"
                                           :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                            name="Shipping Method"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-shipping-2"
                                label="Shipping Method:"
                                label-for="input-shipping-method"
                        >
                            <b-form-select v-model="shippingSelected" :options="shippingOptions"
                                           id="input-shipping-method-2"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider
                            name="Tracking Number"
                            :rules="{ required: true }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                id="input-group-tracking"
                                label="Tracking Number:"
                                label-for="input-tracking-number"
                        >
                            <b-form-input v-model="trackingNumber" type="text" id="input-tracking-number"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <b-row>
            <b-col>
                <b-alert show variant="danger"><i class="fa-duotone fa-exclamation-triangle fa-2x fa-fw"></i> <span class="h3">Order not found!</span>
                </b-alert>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col>
                <h3>Search for a customer:</h3>
                <b-form @submit="getCustomers">
                    <b-form-group
                            id="input-group-1"
                            label="Customer's Name:"
                            label-for="input-1"
                    >
                        <label class="sr-only" for="inline-form-input-name">Name</label>
                        <b-form-input
                                id="input-1"
                                v-model="form.name"
                                type="text"
                                required
                                placeholder="Jane Doe"
                        ></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Search</b-button>
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-table id="intake-outstanding-results" ref="intakeOutstandingResults" striped hover borderless
                         v-if="showTable"
                         tbody-tr-class="text-center"
                         head-variant="dark"
                         primary-key="id"
                         no-provider-paging
                         no-provider-sorting
                         no-provider-filtering
                         show-empty
                         :busy.sync="isBusy"
                         :fields="fields"
                         :items="items">
                    <template v-slot:head(actions)="data">
                    </template>
                    <template v-slot:cell(address)="data">
                        <div>{{ data.item.address.address1 }}</div>
                        <div v-if="data.item.address.address2">{{ data.item.address.address2 }}</div>
                        <div>{{ data.item.address.city }}, {{ data.item.address.state }} {{ data.item.address.zip }}
                        </div>
                    </template>
                    <template v-slot:cell(order_id)="data">
                        <div>{{ data.item.orders && data.item.orders.data && data.item.orders.data.length != 0 ? data.item.orders.data[data.item.orders.data.length-1].id : 'Unknown' }}</div>
                    </template>
                    <template v-slot:cell(actions)="data">                        &nbsp;
                        <b-button @click="gotoOrder(data.item)" variant="primary"><i
                                class="fa-regular fa-cart-plus fa-fw"></i> Goto Order
                        </b-button>
                    </template>
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="isBusy"></LoadingSpinner>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import {each} from 'lodash';

    export default {
        name: 'qa-not-found',
        components: {
            LoadingSpinner
        },
        data() {
            return {
                isBusy: false,
                showTable: false,
                chosenCustomerId: null,
                orderId: null,
                modalShow: null,
                modalNewPackageShow: null,
                fields: [
                    {key: 'id', label: 'Customer #', class: 'text-center'},
                    {key: 'order_id', label: 'Order #', class: 'text-center'},
                    {key: 'full_name', label: 'Name', class: 'text-center'},
                    {key: 'address', label: 'Address', class: 'text-center'},
                    'actions',
                ],
                items: [],
                form: {
                    name: null,
                    order_id: null,
                },
                shippingSelected: null,
                shippingOptions: [],
                brandSelected: 1,
                brandOptions: [],
                trackingNumber: this.$route.params.tracking_number,
            };
        },
        created() {
            this.$http.get('/shippers')
                .then(response => {
                    each(response.data.data, item => {
                        this.shippingOptions.push({value: item.id, text: item.carrier + ' - ' + item.name});
                    });
                });
            this.$http.get('/brands')
                .then(response => {
                    each(response.data.data, item => {
                        this.brandOptions.push({value: item.id, text: item.name});
                    });
                });
        },
        methods: {
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            getCustomers(event) {
                var _this = this;
                event.preventDefault();
                this.isBusy = true;
                this.showTable = true;
                this.$http.get('/search/customers', {
                    params: {
                        q: this.form.name
                    }
                })
                    .then(response => {
                        this.items = response.data.data;
                        for(var i = 0; i <  this.items.length; i++)
                        {
                            var orders = this.items[i].orders.data;
                            this.items[i].latest_order = orders.length == 0 ? null : orders[orders.length - 1];
                        }
                        _this.isBusy = false;
                    });
            },
            gotoOrder(customer){
                let order = customer.orders.data[customer.orders.data.length-1];
                console.log(customer);
                this.$router.replace({
                    path: '/quality-assurance/view/' + order.id,
                });
            },
            confirmCreateOrderForCustomer(id) {
                this.chosenCustomerId = id;
                this.modalShow = true;
            },
            confirmCreatePackagingForExisting(id,order_id){
                this.chosenCustomerId = id;
                this.orderId = order_id;
                this.modalNewPackageShow = true;
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.createOrderForCustomer();
            },
            handleOKAddPackage(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.addTrackingToOrder();
            },
            addTrackingToOrder(){
                this.showTable = false;
                this.isBusy = true;
                this.$http.post('/orders/' + this.orderId + '/trackingnumbers', {
                    order_id: this.orderId,
                    shipper_id: this.shippingSelected,
                    tracking_number: this.trackingNumber,
                    status: 'delivered',
                })
                    .then(response => {
                        console.log(response);
                        this.$router.replace({
                            path: '/intake/view/' + response.data.data.tracking_number,
                            query: {order: response.data.data.order_id}
                        })
                            .catch(err => {
                                console.log(err);
                            });
                    });

            },
            createOrderForCustomer() {
                this.showTable = false;
                this.isBusy = true;
                let payload = {
                    brand_id: this.brandSelected,
                    payment_method: 'company-check'
                };
                this.$http.post('/customers/' + this.chosenCustomerId + '/orders', payload)
                    .then(response => {
                        this.orderId = response.data.data.id;
                        this.addTrackingToOrder();
                    });
            }
        }
    };
</script>

<style scoped>

</style>
